import { HttpClient } from '@angular/common/http'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Address, TranslationService } from '@spartacus/core'
import { Card } from '@spartacus/storefront'
import { AddressBookComponent, AddressBookComponentService } from '@spartacus/user/profile/components'
import { combineLatest, Observable, Subscription } from 'rxjs'
import { map } from 'rxjs/operators'
import { AddressType } from '../../../models/enum/address.enum'
import { AppConfigurationService } from '../../../services/app-configuration.service'
import { CustomGlobalMessageService } from '../../../services/shared/custom-global-message/custom-global-message.service'
import { OrganizationUsersService } from '../../../services/shared/organization-users/organization-users.service'

@Component({
  selector: 'app-custom-address-book',
  templateUrl: './custom-address-book.component.html',
  styleUrls: ['./custom-address-book.component.scss'],
  standalone: false
})
export class CustomAddressBookComponent extends AddressBookComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription()
  public addressType = AddressType
  public spinner: boolean = false
  public billingAddresses$: Observable<Address[]>
  public shippingAddresses$: Observable<Address[]>

  constructor(
    public appConfigurationService: AppConfigurationService,
    public http: HttpClient,
    public orgUsersService: OrganizationUsersService,
    public globalMessageService: CustomGlobalMessageService,
    protected addressBookComponentService: AddressBookComponentService,
    protected translation: TranslationService
  ) {
    super(addressBookComponentService, translation, globalMessageService)
  }

  ngOnInit() {
    super.ngOnInit()
    this.getBillingShippingAddresses()
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  public getBillingShippingAddresses(): void {
    this.billingAddresses$ = this.addresses$.pipe(
      map((adresses) => adresses.filter((address) => address.shippingAddress === false))
    )
    this.shippingAddresses$ = this.addresses$.pipe(
      map((adresses) => adresses.filter((address) => address.shippingAddress === true))
    )
  }

  getCardContent(address: Address): Observable<Card> {
    return combineLatest([
      this.translation.translate('addressCard.defaultAddress'),
      this.translation.translate('addressCard.setAsDefault'),
      this.translation.translate('addressCard.shippingAddress'),
      this.translation.translate('addressCard.billingAddress')
    ]).pipe(
      map(([defaultText, setAsDefaultText, shippingAddress, billingAddress]) => {
        let region = ''

        if (address?.region && address?.region?.isocode) {
          region = address?.region?.isocode + ', '
        }

        const actions: { name: string; event: string }[] = []
        if (!address.defaultAddress) {
          actions.push({ name: setAsDefaultText, event: 'default' })
        }

        return {
          text: [
            address.line1,
            address.line2,
            address.town + ', ' + region + address.country.isocode,
            address.postalCode,
            address.phone
          ],
          actions,
          header: address.defaultAddress ? `${defaultText}` : '',
          tag: address.shippingAddress ? shippingAddress : billingAddress
        } as Card
      })
    )
  }
}
